import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Table, Pager, Tabs, Chip, Person, fmt, when } from "./kit";

const left = (d) => {
  const s = Math.max(0, Math.floor((new Date(d) - Date.now()) / 1000));
  return `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;
};

const cell = { padding: "6px 8px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13, width: 120 };
const small = { fontSize: 12, color: "#6B7280" };

/// PK kalkani ve ceza ayarlari.
const PkSettings = () => {
  const [cfg, setCfg] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = useCallback(async () => {
    const r = await api.config();
    if (r?.status) {
      setCfg({
        pkShieldSec: Number(r.config.pkShieldSec) || 0,
        pkPunishSec: Number(r.config.pkPunishSec) || 0,
      });
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  if (!cfg) return null;

  const save = async () => {
    setSaving(true);
    const r = await api.saveConfig(cfg);
    setSaving(false);
    if (!r?.status) return window.alert(r?.message || "Kaydedilemedi");
    load();
  };

  return (
    <div className="card" style={{ marginBottom: 12 }}>
      <div className="card-body">
        <b style={{ fontSize: 14 }}>PK ayarları</b>
        <div className="d-flex" style={{ gap: 16, marginTop: 10, flexWrap: "wrap" }}>
          <div>
            <div style={small}>Kalkan süresi (saniye)</div>
            <input
              style={cell}
              type="number"
              value={cfg.pkShieldSec}
              onChange={(e) => setCfg({ ...cfg, pkShieldSec: Number(e.target.value) })}
            />
            <div style={{ ...small, maxWidth: 260 }}>Son bu kadar saniyede skor gizlenir, iki taraf da hediye yağdırır. 0 = kapalı.</div>
          </div>
          <div>
            <div style={small}>Ceza süresi (saniye)</div>
            <input
              style={cell}
              type="number"
              value={cfg.pkPunishSec}
              onChange={(e) => setCfg({ ...cfg, pkPunishSec: Number(e.target.value) })}
            />
            <div style={{ ...small, maxWidth: 260 }}>Kaybeden yayıncıda bu kadar süre ceza şeridi görünür. 0 = kapalı.</div>
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <button className="btn btn-primary btn-sm" disabled={saving} onClick={save}>
              {saving ? "Kaydediliyor…" : "Kaydet"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const PkBattles = () => {
  const [state, setState] = useState("live");
  const [page, setPage] = useState(1);
  const [data, setData] = useState({ battles: [], total: 0 });
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    const res = await api.pk({ state, page, size: 20 });
    if (res?.status) setData(res);
    setLoading(false);
  }, [state, page]);

  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);

  const end = async (b) => {
    const reason = window.prompt("Düelloyu erken bitirme sebebi:", "");
    if (reason === null) return;
    const res = await api.endPk(b._id, reason);
    if (!res?.status) window.alert(res?.message || "Bitirilemedi");
    load();
  };

  return (
    <>
      <PageHead title="PK Düelloları" sub="Canlı düellolar 10 saniyede bir yenilenir. Kurallara aykırı düelloyu buradan bitirebilirsin." />
      <PkSettings />
      <Tabs
        value={state}
        onChange={(v) => {
          setState(v);
          setPage(1);
        }}
        tabs={[
          ["live", "Canlı"],
          ["pending", "Davet bekleyen"],
          ["ended", "Biten"],
          ["", "Tümü"],
        ]}
      />
      <Table
        loading={loading}
        head={["Mavi taraf", "Skor", "Kırmızı taraf", "Süre", "Kazanan", "Tarih", ""]}
        rows={data.battles.map((b) => (
          <tr key={b._id}>
            <td>
              <Person image={b.hostAImage} name={b.hostAName} />
            </td>
            <td style={{ whiteSpace: "nowrap" }}>
              <b>{fmt(b.scoreA)}</b> — <b>{fmt(b.scoreB)}</b>
            </td>
            <td>
              <Person image={b.hostBImage} name={b.hostBName} />
            </td>
            <td>{b.state === "live" && b.endsAt ? <Chip kind="live">{left(b.endsAt)}</Chip> : `${Math.round((b.durationSec || 0) / 60)} dk`}</td>
            <td>
              {b.state !== "ended" ? (
                <Chip kind="wait">{b.state === "live" ? "Sürüyor" : "Bekliyor"}</Chip>
              ) : b.isDraw ? (
                "Berabere"
              ) : String(b.winner) === String(b.hostA) ? (
                b.hostAName
              ) : (
                b.hostBName
              )}
            </td>
            <td>{when(b.createdAt)}</td>
            <td>
              {b.state !== "ended" && (
                <button className="btn btn-sm btn-danger badu-destructive" onClick={() => end(b)}>
                  Bitir
                </button>
              )}
            </td>
          </tr>
        ))}
      />
      <Pager page={page} size={20} total={data.total} onChange={setPage} />
    </>
  );
};

export default PkBattles;
